import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { objectFitCoverImageStyles, SDUIImage } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Image/SDUIImage";
import { convertServerResponsivePropertyToClientResponsiveProperty, getResponsiveValueAtIndex } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import { buttonWidthContainer, centerAlignedWrapper, imageStyle } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/VerticalModalTextImageBanner/__internal__/style.css";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import { SDUITypographyRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
var OPTIMIZE_IMAGE_OPTIONS = {
    mobileAndAbove: {
        width: 430
    },
    tabletAndAbove: {
        height: 200
    }
};
export var SDUIVerticalModalTextImageBannerRenderer = function(param) {
    var bannerComponent = param.bannerComponent, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour, onClickClientDismissHandler = param.onClickClientDismissHandler;
    var images = bannerComponent.images, responsive_images = bannerComponent.responsive_images, title = bannerComponent.title, tagline = bannerComponent.tagline, description = bannerComponent.description, button = bannerComponent.button, disclaimer = bannerComponent.disclaimer;
    var responsiveImages = convertServerResponsivePropertyToClientResponsiveProperty(images, function(img) {
        return img;
    }, responsive_images);
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(SDUIImage, {
                responsiveImage: getResponsiveValueAtIndex(responsiveImages, 0, IImage.build()),
                optimizeImageOptions: OPTIMIZE_IMAGE_OPTIONS,
                renderBehaviour: renderBehaviour,
                className: imageStyle,
                imageStyles: objectFitCoverImageStyles
            }),
            /*#__PURE__*/ _jsxs(Column, {
                style: {
                    padding: getSpacing("5x", "4x"),
                    zIndex: 1
                },
                children: [
                    tagline ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                textElement: tagline,
                                loggingData: loggingData
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "3x"
                            })
                        ]
                    }) : null,
                    title ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                textElement: title,
                                loggingData: loggingData
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: {
                                    mobileAndAbove: "3x",
                                    tabletAndAbove: "2x"
                                }
                            })
                        ]
                    }) : null,
                    description.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            description.map(function(descriptionElement, index) {
                                return /*#__PURE__*/ _jsxs(React.Fragment, {
                                    children: [
                                        index > 0 ? /*#__PURE__*/ _jsx(Spacer, {
                                            height: "1/2x"
                                        }) : null,
                                        /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                            textElement: descriptionElement,
                                            loggingData: loggingData
                                        })
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "3x"
                            })
                        ]
                    }) : null,
                    button ? /*#__PURE__*/ _jsxs("div", {
                        className: centerAlignedWrapper,
                        children: [
                            /*#__PURE__*/ _jsx(SDUIButtonRenderer, {
                                buttonElement: button,
                                className: buttonWidthContainer,
                                loggingData: loggingData,
                                fireLegacyOnClickEvent: true,
                                onClickClientDismissHandler: onClickClientDismissHandler
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: {
                                    mobileAndAbove: "3x",
                                    tabletAndAbove: "2x"
                                }
                            })
                        ]
                    }) : null,
                    disclaimer ? /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                            textElement: disclaimer,
                            loggingData: loggingData
                        })
                    }) : null
                ]
            })
        ]
    });
};
